import {
  SET_MENU_CLICKED_CONTROL_MODAL_DATA,
  SET_CATALOG_MODAL_DELETE_ROW_ID,
} from "./mutation-types";

export default {
  [SET_MENU_CLICKED_CONTROL_MODAL_DATA](state, payload) {
    state.menuClickControlModalData = payload;
  },
  [SET_CATALOG_MODAL_DELETE_ROW_ID](state, payload) {
    state.catalogModalDeleteRowId = payload;
  },
};
